export const ExternalRoutesVariables = {
  External: {
    FAQ: 'https://hublohelp.zendesk.com/hc',
    ContactSupport: 'https://hublohelp.zendesk.com/hc/fr/requests/new',
    HubloLabApp: 'https://hublolabs.bubbleapps.io',
    RGPD: 'https://hublo-public.s3.eu-west-1.amazonaws.com/HUBLO-Clauses-RGPD-+Agences+interim.pdf',
    GoogleMapsAddress: 'https://www.google.com/maps/search/?api=1&query=',
  },
}
